// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__vbDbd","logo":"styles_logo__x887G","logoLink":"styles_logoLink__EMaEe","dpBtn":"styles_dpBtn__LI9Ym","search":"styles_search__faOr2"};